import { eCDV3ItemTypes } from './eCDV3ItemTypes';

export const CDItemTypesBySection = {
  /** Sections A - J on a Closing Disclosure */
  aj: [
    eCDV3ItemTypes.percentage_of_loan_amount,
    eCDV3ItemTypes.origination_fee_other,
    eCDV3ItemTypes.title_fee,
    eCDV3ItemTypes.title_fee_other,
    eCDV3ItemTypes.other_loan_cost,
    eCDV3ItemTypes.endorsement,
    eCDV3ItemTypes.endorsement_other,
    eCDV3ItemTypes.recording_fee,
    eCDV3ItemTypes.recording_fee_other,
    eCDV3ItemTypes.tax,
    eCDV3ItemTypes.tax_other,
    eCDV3ItemTypes.interest_prepayment,
    eCDV3ItemTypes.non_interest_prepayment,
    eCDV3ItemTypes.prepayment_other,
    eCDV3ItemTypes.escrow_at_closing,
    eCDV3ItemTypes.escrow_at_closing_other,
    eCDV3ItemTypes.aggregate_adjustment,
    eCDV3ItemTypes.other_fee,
    eCDV3ItemTypes.lender_credit,
    eCDV3ItemTypes.payoff,
    eCDV3ItemTypes.property_taxes,
    eCDV3ItemTypes.hoa_fee,
    eCDV3ItemTypes.sales_tax,
    eCDV3ItemTypes.appraisal_fee,
  ],
  /** Sections K - N on a Closing Disclosure */
  kn: [
    eCDV3ItemTypes.sale_price_of_property,
    eCDV3ItemTypes.personal_property_sale,
    eCDV3ItemTypes.buyer_deposit,
    eCDV3ItemTypes.loan_amount,
    eCDV3ItemTypes.existing_loans_assumed,
    eCDV3ItemTypes.seller_credit,
    eCDV3ItemTypes.seller_excess_deposit,
    eCDV3ItemTypes.buyer_credit_from_seller,
    eCDV3ItemTypes.buyer_credit_from_third_party,
    eCDV3ItemTypes.buyer_reimbursement_to_seller,
    eCDV3ItemTypes.buyer_reimbursement_other_to_seller,
    eCDV3ItemTypes.buyer_reimbursement_from_seller,
    eCDV3ItemTypes.buyer_reimbursement_other_from_seller,
    eCDV3ItemTypes.buyer_reimbursement_to_third_party,
  ],
};
